// Types
import angular from 'angular';
import { StateViewModelValidator } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/models/validators/StateViewModelValidator';
import { DESK_ID_PREFIX, STATE_ID_FALLBACK, STATE_ID_END, STATE_ID_ONBOARDING, SUBFLOW_ID_PREFIX, ANSWERS_ID_PREFIX } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/services/BuilderStateService';
import { ActionsUpdateAndSaveState } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/actions/components/actions/actions.dispatcher';
import { ContentUpdateAndSave } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/content/components/contents/contents.dispatcher';
import { OutputAddNewState, OutputAddNewSurvey, OutputChange, OutputUpdateAndSaveState } from 'modules/application/detail/portal-submodule-builder-pipeline/templates/builder/tabs/outputs/components/outputs/outputs.dispatcher';
import { BuilderFeatures } from './BuilderFeatures';
import { ActionTabIAction, ContentActionTabIAction, StateTagsIAction, StateTitleIAction } from './historyActions';
import { ActionViewModel } from './models/viewModels/ActionViewModel';
import { BuilderStore } from './store/BuilderStore';
import { validateTab } from './tabs/actions/components/actions/actions.component';
import { validateContentTab } from './tabs/content/components/contents/contents.component';
import { SmartSalesConstants } from './smartSales/SmartSalesConstants';
import { ExclusiveComponentsConstants } from './exclusiveComponents/ExclusiveComponentsConstants';
import './exclusiveComponents/ExclusiveComponents.scss';
import { ActionType } from './models/Action';
import { SetVariableActionSettings } from './models/SetVariableActionSettings';
const builderStore = BuilderStore.getInstance();
var TagChangesAction;
(function (TagChangesAction) {
    TagChangesAction["AddTag"] = "addTag";
    TagChangesAction["RemoveTag"] = "removeTag";
    TagChangesAction["ChangeTagColor"] = "changeTagColor";
})(TagChangesAction || (TagChangesAction = {}));
export class BuilderSidebarController {
    static $inject = ['PipelineTagsService', 'close', 'targetState', '$scope', 'states', 'PipelineBuilderSegmentService', 'PipelineActionContentService', 'application', '$onOutputChange', '$onAddNewState', '$onAddNewSurvey', 'ChatService', 'AccountService2', 'UndoRedoService', 'PipelineSmartSalesService', 'AnswersService', '$state', '$rootScope', 'AutoSaveService', 'TranslateService', '$translate', 'SidebarContentService', 'PipelineExclusiveComponentsService'];
    constructor(PipelineTagsService, close, targetState, $scope, states, PipelineBuilderSegmentService, PipelineActionContentService, application, //Used in view
    $onStateChanged, $onOutputChange, $onAddNewState, $onAddNewSurvey, ChatService, AccountService2, UndoRedoService, PipelineSmartSalesService, AnswersService, $state, $rootScope, AutoSaveService, TranslateService, $translate, SidebarContentService, PipelineExclusiveComponentsService) {
        this.PipelineTagsService = PipelineTagsService;
        this.close = close;
        this.targetState = targetState;
        this.$scope = $scope;
        this.states = states;
        this.PipelineBuilderSegmentService = PipelineBuilderSegmentService;
        this.PipelineActionContentService = PipelineActionContentService;
        this.application = application;
        this.$onStateChanged = $onStateChanged;
        this.$onOutputChange = $onOutputChange;
        this.$onAddNewState = $onAddNewState;
        this.$onAddNewSurvey = $onAddNewSurvey;
        this.ChatService = ChatService;
        this.AccountService2 = AccountService2;
        this.UndoRedoService = UndoRedoService;
        this.PipelineSmartSalesService = PipelineSmartSalesService;
        this.AnswersService = AnswersService;
        this.$state = $state;
        this.$translate = $translate;
        this.SidebarContentService = SidebarContentService;
        this.PipelineExclusiveComponentsService = PipelineExclusiveComponentsService;
        this.smartSalesCta = {};
        this.hasInput = false;
        this.isAnswersState = false;
        this.isUndoRedoActionOnTags = false;
        this.isSubflowState = false;
        this.isCtaEnabled = true;
        this.canAddTags = false;
        this.availableAssistants = [];
        this.useConfigurationsApplication = false;
        this.isModelConfigurationOpen = false;
        this.isCatalogManagerModalOpen = false;
        this.isCatalogDocumentsModalOpen = false;
        this.isAiOutputEditModalOpen = false;
        this.isGuardrailModalOpen = false;
        this.isAiSettingsLoading = false;
        this.isCatalogDocumentsLoading = false;
        this.catalogs = [];
        this.agentCatalogs = [];
        this.catalogDocuments = [];
        this.availableModels = [];
        this.isActionModalOpen = false;
        this.isEditActionSchemaModalOpen = false;
        this.getSmartSalesLink = async () => {
            this.PipelineSmartSalesService.setTokenApplicationByState(this.state);
            const { shortnedLink } = await this.PipelineSmartSalesService.createUserSession('user-test');
            return shortnedLink;
        };
        this.handleSmartSalesButtonClick = async () => {
            const catalogLink = await this.getSmartSalesLink();
            window.open(catalogLink, '_blank');
        };
        this.handleSelectedAssistantChanges = async (event) => {
            const currentState = angular.copy(this.state);
            const leavingActions = [
                {
                    ...currentState.$leavingCustomActions[0],
                    settings: {
                        ...currentState.$leavingCustomActions[0].settings,
                        AssistantId: event.detail.value,
                    },
                },
            ];
            this.state.$leavingCustomActions = leavingActions;
            this.$onStateChanged(this.state);
        };
        this.contextVariables = [];
        this.onCtaInputChange = (event) => {
            const field = event.target.dataset?.cta;
            const validFields = ['header', 'body', 'footer', 'button'];
            if (!validFields.includes(field)) {
                return;
            }
            this.smartSalesCta[field] = event.detail.value;
        };
        this.resetCtaInformation = async () => {
            this.smartSalesCta = {
                header: await this.$translate('builder.smartSales.defaultCtaMessage.header'),
                body: await this.$translate('builder.smartSales.defaultCtaMessage.body'),
                footer: await this.$translate('builder.smartSales.defaultCtaMessage.footer'),
                button: await this.$translate('builder.smartSales.defaultCtaMessage.button'),
            };
            this.updateCtaInTheState();
        };
        this.updateCtaInTheState = () => {
            if (!this.smartSalesCta.body.length || !this.smartSalesCta.button.length) {
                return;
            }
            this.state.$enteringCustomActions.find(action => action.$title === SmartSalesConstants.WA_CTA_ACTION_NAME).settings.value = JSON.stringify(this.smartSalesCta);
        };
        this.updateBlipChatCopyAndPasteInTheState = (document) => {
            this.state.$contentActions.find(action => action.action.settings.type === ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_TYPE).action.settings.rawContent = JSON.stringify(document.content);
        };
        this.isCtaAvailable = () => {
            return this.PipelineSmartSalesService.isStateVersionAvailableToCta(this.state.stateVersion);
        };
        this.isCtaAvailableToggle = () => {
            return this.PipelineSmartSalesService.isStateVersionAvailableToCtaToggle(this.state.stateVersion);
        };
        this.isSmartSalesStateOutdated = () => {
            return !(this.PipelineSmartSalesService.isSmartSalesStateVersionUpToDate(this.state.stateVersion));
        };
        this.toggleCta = async (event) => {
            this.isCtaEnabled = event.detail.checked;
            this.state.$enteringCustomActions.find(action => action.$title === SmartSalesConstants.WA_WEB_ACTION_NAME).settings.value = JSON.stringify(event.detail.checked);
            this.$scope.$apply();
        };
        this.isAssistantLoading = true;
        this.stateViewModelValidator = new StateViewModelValidator();
        AutoSaveService.registerAction($rootScope, this, this.updateAndSaveState.bind(this));
        this.showDetail = false;
        this.inputValidationRules = [];
        this.currentLanguage = TranslateService.getCurrentLanguage();
        this.isDeskState = this.targetState.id.startsWith(DESK_ID_PREFIX);
        this.isSmartSalesState = this.targetState.id.startsWith(SmartSalesConstants.STATE_ID_PREFIX);
        this.isBlipChatCopyAndPaste = this.targetState.id.startsWith(ExclusiveComponentsConstants.BLIP_CHAT_COPY_AND_PASTE_PREFIX);
        this.isAnswersState = this.targetState.id.startsWith(ANSWERS_ID_PREFIX);
        this.init();
        this.addContentEnabled =
            this.targetState.id != STATE_ID_ONBOARDING &&
                this.targetState.id != STATE_ID_FALLBACK &&
                this.targetState.id != STATE_ID_END &&
                !this.isDeskState &&
                !this.isSmartSalesState &&
                !this.isBlipChatCopyAndPaste;
        this.hasOutputTab = this.targetState.id !== STATE_ID_END;
        this.hasActionsTab = this.targetState.id !== STATE_ID_END && !this.isDeskState && !this.isSmartSalesState && !this.isAnswersState;
        this.account = {};
    }
    async init() {
        /**
         * Avoid to refactor all view variables when undo/redo
         * feature is unabled
         * */
        this.state = this.targetState;
        await this.checkFeatures();
        this.isSubflowState = this.state.id.includes(SUBFLOW_ID_PREFIX);
        this.canAddTags = this.isSubflowState;
        this.oldState = { ...this.state };
        // Initialize context variables for onboarding state
        this.initContextVariables();
        this.startSubscribers();
        this.initializeProxy();
        this.account = await this.AccountService2.me();
        this.PipelineBuilderSegmentService.setApplication(this.application);
        this.PipelineSmartSalesService.setApplication(this.application, this.useConfigurationsApplication);
        this.defaultTextMsg = await this.$translate('builder.smartSales.cta.configure.defaultCatalogMessage');
        // Remove the BLiP Chat Widget
        if (this.ChatService.built) {
            this.ChatService.destroy();
        }
        if (this.isAnswersState) {
            this.availableAssistants = (await this.AnswersService.getPublishedAssistants()).map(assistant => ({ value: assistant.assistantId, label: assistant.assistantName }));
            this.isAssistantLoading = false;
        }
        if (this.isSmartSalesState) {
            await this.initSmartSales();
        }
        if (this.isBlipChatCopyAndPaste) {
            const blipChatCopyAndPasteDocument = this.PipelineExclusiveComponentsService.getBlipChatCopyAndPaste(this.state, this.updateBlipChatCopyAndPasteInTheState);
            this.blipChatCopyAndPaste = blipChatCopyAndPasteDocument;
        }
    }
    async initSmartSales() {
        this.smartSalesLink = await this.getSmartSalesLink();
        const ctaInfo = this.PipelineSmartSalesService.getCtaInformation(this.state);
        const isCtaenabled = this.PipelineSmartSalesService.getSmartSalesWebLinkEnabled(this.state);
        if (ctaInfo) {
            this.smartSalesCta = ctaInfo;
        }
        if (isCtaenabled !== undefined) {
            this.isCtaEnabled = isCtaenabled;
            this.state
                .$enteringCustomActions
                .find(action => action.$title === SmartSalesConstants.DEFAULT_DISABLED_CTA_ACTION_NAME).settings.value = this.defaultTextMsg;
        }
    }
    startSubscribers() {
        const stateChanges$ = builderStore.getStateChanges()
            .subscribe(data => {
            if (data?.id && data.id === this.targetState.id) {
                const updatedData = angular.copy(data);
                /**
                 * Update every property avoid override Proxy because
                 * changes still need to be watched
                 */
                for (const prop in updatedData) {
                    if (updatedData.hasOwnProperty(prop)) {
                        this.targetState[prop] = updatedData[prop];
                    }
                }
                this.updateAndSaveState();
            }
        });
        this.$scope.$on('$destroy', () => {
            stateChanges$.unsubscribe();
        });
    }
    async checkFeatures() {
        this.isBuilderUndoRedoContentEnabled = await BuilderFeatures.builderUndoRedoContentEnabled();
        this.isBuilderUndoRedoActionEnabled = await BuilderFeatures.builderUndoRedoActionEnabled();
        this.isBuilderUndoRedoOutputsEnabled = await BuilderFeatures.builderUndoRedoOutputsEnabled();
        this.isBuilderUndoRedoBlockTagEnabled = await BuilderFeatures.builderUndoRedoBlockTagEnabled();
        this.isBuilderUndoRedoBlockNameEnabled = await BuilderFeatures.builderUndoRedoBlockNameEnabled();
        this.isBuilderAddOutputConditionsOnContentChange = await BuilderFeatures.builderAddOutputConditionsOnContentChange();
        this.useConfigurationsApplication = await BuilderFeatures.isUseConfigurationsDomainOnMiscOperationsGetEnabled();
    }
    initializeProxy() {
        this.state = new Proxy(this.targetState, {
            set: (target, key, value) => {
                switch (key) {
                    case 'this.state.$contentActions':
                        this.handleContentActionChanges(value);
                        break;
                    case 'this.state.$enteringCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    case 'this.state.$leavingCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    case 'this.state.$localCustomActions':
                        this.handleActionsChanges(key, value);
                        break;
                    default:
                        // just pass through
                        break;
                }
                return Reflect.set(target, key, value);
            },
        });
    }
    /**
     * Handle proxy changes to made undo/redo
     * @param value
     */
    handleContentActionChanges(contentActions) {
        if (!this.isBuilderUndoRedoContentEnabled) {
            return;
        }
        let allOutputConditions = angular.copy(this.state.$conditionOutputs);
        if (this.isBuilderAddOutputConditionsOnContentChange) {
            contentActions.forEach(contentAction => {
                allOutputConditions = this.PipelineActionContentService.getAllOutputConditions(contentAction, this.state.$conditionOutputs) || allOutputConditions;
            });
        }
        const changeContentTabIAction = new ContentActionTabIAction({
            execute: (data) => {
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                    $contentActions: data.after,
                    $conditionOutputs: allOutputConditions,
                });
                validateContentTab(this.state);
            },
            undo: (data) => {
                const currentState = angular.copy(this.state);
                builderStore.setState({
                    ...currentState,
                    $contentActions: data.before,
                    $conditionOutputs: data.outputConditionsBefore,
                });
                validateContentTab(this.state);
            },
            data: {
                after: angular.copy(contentActions),
                before: angular.copy(this.state.$contentActions),
                outputConditionsBefore: this.state.$conditionOutputs,
                state: {
                    id: this.state.id,
                    $title: this.state.$title,
                },
            },
        });
        this.UndoRedoService.add(changeContentTabIAction);
    }
    /**
     * Handle proxy changes to made undo/redo
     * @param value
     */
    handleActionsChanges(type, value) {
        if (!this.isBuilderUndoRedoActionEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const actionType = angular.copy(this.state[type]).length < value.length
            ? 'add'
            : 'delete';
        const segmentPayload = {
            blockId: currentState.id,
            blockName: currentState.$title,
            actionType: actionType,
        };
        const changeContentTabIAction = new ActionTabIAction({
            execute: (data) => {
                this.state[type] = data.after;
                data.after.forEach(item => {
                    item.settings = item.settings || {};
                });
                this.updateAndSaveState();
                validateTab(this.state);
                this.trackBlockActionRedo(true, segmentPayload);
            },
            undo: (data) => {
                /*
                * It has been created an validation which if the data after is greather than
                * data before (length), it's happening a block exclusion action, so, we
                * filter the opened sideabars to filter sidebars which is an Action Sidebar
                * and we use the method to close it.
                */
                const openedSidebarsIds = this.SidebarContentService.getSidebars().map(({ sidebarId }) => sidebarId).filter(s => s != undefined);
                const actionsId = data.before.map(({ $id }) => $id);
                openedSidebarsIds?.forEach(openedSidebarId => {
                    if (!actionsId.includes(openedSidebarId)) {
                        const sidebarToBeClosed = this.SidebarContentService
                            .getSidebars()
                            .find(({ sidebarId }) => sidebarId == openedSidebarId);
                        this.SidebarContentService.cleanAndClose(undefined, sidebarToBeClosed);
                    }
                });
                this.state[type] = data.before;
                this.updateAndSaveState();
                validateTab(this.state);
                this.trackBlockActionUndo(true, segmentPayload);
            },
            data: {
                after: angular.copy(value),
                before: angular.copy(this.state[type]),
                state: {
                    id: this.state.id,
                    $title: this.state.$title,
                },
            },
        });
        this.UndoRedoService.add(changeContentTabIAction);
    }
    removeTagUndoItem(tagId) {
        let itemIndex = 0;
        let userAction;
        this.UndoRedoService.getNormalStack().getStore().map(stackItem => {
            if (!Object.keys(stackItem.data)) {
                return;
            }
            if (Array.isArray(Object(stackItem?.data)?.after)) {
                Object(stackItem.data).after.map(tagAction => {
                    if (tagAction?.id == tagId) {
                        this.UndoRedoService.getNormalStack().removeItemByIndex(itemIndex);
                        userAction = stackItem;
                    }
                });
            }
            itemIndex += 1;
        });
        return userAction;
    }
    handleTagActionChanges(tagAction, tagChanged = undefined) {
        if (!this.isBuilderUndoRedoBlockTagEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const oldState = angular.copy({
            ...this.oldState,
            $tags: tagAction == TagChangesAction.ChangeTagColor
                ? Object(this.removeTagUndoItem(tagChanged.props.id).data)?.before
                : this.oldState.$tags,
        });
        const changeStateTagsIAction = new StateTagsIAction({
            execute: (data) => {
                builderStore.setState({
                    ...currentState,
                    $tags: data.after,
                });
            },
            undo: (data) => {
                builderStore.setState({
                    ...currentState,
                    $tags: data.before,
                });
            },
            data: {
                after: currentState.$tags,
                before: oldState.$tags,
                state: {
                    id: currentState.id,
                    $title: currentState.$title,
                },
            },
        });
        this.UndoRedoService.add(changeStateTagsIAction);
    }
    handleTitleActionChanges() {
        if (!this.isBuilderUndoRedoBlockNameEnabled) {
            return;
        }
        const currentState = angular.copy(this.state);
        const changeStateTitleIAction = new StateTitleIAction({
            execute: (data) => {
                builderStore.setState({
                    ...currentState,
                    $title: data.after,
                });
            },
            undo: (data) => {
                builderStore.setState({
                    ...currentState,
                    $title: data.before,
                });
            },
            data: {
                after: this.state.$title,
                before: this.oldState.$title,
                state: {
                    id: currentState.id,
                    $title: currentState.$title,
                },
            },
        });
        this.UndoRedoService.add(changeStateTitleIAction);
    }
    isDefaultNode() {
        const listDefaultNodeId = [STATE_ID_ONBOARDING, STATE_ID_FALLBACK, STATE_ID_END];
        return listDefaultNodeId.some((element) => element === this.state.id);
    }
    isOnboardingState() {
        return this.state.id === STATE_ID_ONBOARDING;
    }
    initContextVariables() {
        if (this.isOnboardingState()) {
            this.loadExistingContextVariables();
        }
    }
    loadExistingContextVariables() {
        this.contextVariables = [];
        if (this.state.$enteringCustomActions) {
            this.state.$enteringCustomActions.forEach((action, index) => {
                if (action.type === ActionType.SetVariable) {
                    const settings = action.settings;
                    this.contextVariables.push({
                        key: settings.variable || '',
                        value: settings.value || '',
                        id: `var_${index}_${Date.now()}`,
                    });
                }
            });
        }
        if (this.contextVariables.length === 0) {
            this.contextVariables.push({
                key: '',
                value: '',
                id: `var_${Date.now()}`,
            });
        }
    }
    addContextVariable() {
        this.contextVariables.push({
            key: '',
            value: '',
            id: `var_${Date.now()}`,
        });
    }
    removeContextVariable(index) {
        this.contextVariables.splice(index, 1);
        this.saveContextVariables();
    }
    onContextVariableKeyChange(index) {
        // Auto-fill value when key changes
        const variable = this.contextVariables[index];
        if (variable.key && variable.key.trim()) {
            variable.value = `{{input.content@${variable.key.trim()}}}`;
        }
        else {
            variable.value = '';
        }
        this.saveContextVariables();
    }
    onContextVariableChange() {
        this.saveContextVariables();
    }
    saveContextVariables() {
        // Only save if we're in onboarding state
        if (!this.isOnboardingState()) {
            return;
        }
        const validVariables = this.contextVariables.filter(v => v.key && v.key.trim() && v.value && v.value.trim());
        const newActions = validVariables.map((variable) => new ActionViewModel({
            type: ActionType.SetVariable,
            $title: `Definir ${variable.key}`,
            settings: new SetVariableActionSettings({
                variable: variable.key.trim(),
                value: variable.value.trim(),
            }),
            $invalid: false,
        }));
        // Keep existing entering actions and add new variables
        const existingActions = this.state.$enteringCustomActions || [];
        const nonVariableActions = existingActions.filter(action => action.type !== ActionType.SetVariable);
        this.state.$enteringCustomActions = [...nonVariableActions, ...newActions];
        this.updateAndSaveState();
    }
    onContentAction($action) {
        if ($action.constructor !== ContentUpdateAndSave) {
            throw new Error('Unrecognized content action');
        }
        this.updateAndSaveState();
    }
    async onOutputAction($action) {
        switch ($action.constructor) {
            case OutputUpdateAndSaveState:
                this.updateAndSaveState();
                break;
            case OutputChange:
                await this.$onOutputChange($action);
                break;
            case OutputAddNewState:
                await this.$onAddNewState($action);
                break;
            case OutputAddNewSurvey:
                await this.$onAddNewSurvey($action);
                break;
            default:
                throw new Error('Unrecognized output action');
        }
    }
    async onActionDispatched($action) {
        switch ($action.constructor) {
            case ActionsUpdateAndSaveState:
                await this.updateAndSaveState();
                break;
            default:
                throw new Error(`Unrecognized action dispatcher type: ${$action.constructor}`);
        }
    }
    async updateAndSaveState() {
        if (this.state.$title != this.oldState.$title) {
            this.handleTitleActionChanges();
            this.trackBlockNameEdited();
        }
        this.oldState = { ...this.state };
        await this.$onStateChanged(this.state);
    }
    onTagAdded({ tag }) {
        this.PipelineTagsService.add(tag);
        this.handleTagActionChanges(TagChangesAction.AddTag);
        this.trackBlockTagged();
        this.updateAndSaveState();
    }
    onTagRemoved() {
        this.handleTagActionChanges(TagChangesAction.RemoveTag);
        this.updateAndSaveState();
    }
    onSelectTagColor({ tag }) {
        this.PipelineTagsService.changeBackground(tag);
        this.handleTagActionChanges(TagChangesAction.ChangeTagColor, tag);
        this.updateAndSaveState();
    }
    async closeSidebar() {
        try {
            if (!this.ChatService.built) {
                this.ChatService.build();
            }
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    // Segment Methods
    trackBlockTagged() {
        this.PipelineBuilderSegmentService.trackBlockTagged({
            BlockID: this.state.id,
            ShortNameOfSubflow: this.state.shortNameOfSubflow,
        }, true);
    }
    trackBlockNameEdited() {
        this.PipelineBuilderSegmentService.trackBlockNameEdited({
            BlockID: this.state.id,
            ShortNameOfSubflow: this.state.shortNameOfSubflow,
        }, true);
    }
    trackBlockActionUndo(success, segmentPayload) {
        this.PipelineBuilderSegmentService.trackBlockActionUndo(segmentPayload, success);
    }
    trackBlockActionRedo(success, segmentPayload) {
        this.PipelineBuilderSegmentService.trackBlockActionRedo(segmentPayload, success);
    }
}
// DI annotation for minification safety - order must match constructor parameters
BuilderSidebarController.$inject = [
    'PipelineTagsService',
    'close',
    'targetState',
    '$scope',
    'states',
    'PipelineBuilderSegmentService',
    'PipelineActionContentService',
    'application',
    '$onStateChanged',
    '$onOutputChange',
    '$onAddNewState',
    '$onAddNewSurvey',
    'ChatService',
    'AccountService2',
    'UndoRedoService',
    'PipelineSmartSalesService',
    'AnswersService',
    '$state',
    '$rootScope',
    'AutoSaveService',
    'TranslateService',
    '$translate',
    'SidebarContentService',
    'PipelineExclusiveComponentsService',
];
